module.exports = __webpack_public_path__ + "img/layers-2x.4f0283c.png";